import { defineModelSelectComponent } from "../helpers/model-select-component";
import { EventType } from "~/models/dobby/Event";

export default defineModelSelectComponent({
  name: "EventTypeSelect",
  icon: "event_note",
  placeholder: "Select event type",
  model: EventType,
});
